import React from 'react'
import { sortableContainer, } from 'react-sortable-hoc'

export const SortableContainer = sortableContainer(({ children }) => {
  return <ul style={{ listStyleType: 'none' }}>{children}</ul>
})